/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createNote } from '../fn/notes/create-note';
import { CreateNote$Params } from '../fn/notes/create-note';
import { deleteNote } from '../fn/notes/delete-note';
import { DeleteNote$Params } from '../fn/notes/delete-note';
import { getNote } from '../fn/notes/get-note';
import { GetNote$Params } from '../fn/notes/get-note';
import { getNotes } from '../fn/notes/get-notes';
import { GetNotes$Params } from '../fn/notes/get-notes';
import { Note } from '../models/note';
import { updateNote } from '../fn/notes/update-note';
import { UpdateNote$Params } from '../fn/notes/update-note';

@Injectable({ providedIn: 'root' })
export class NotesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `noteControllerGetNotes()` */
  static readonly NoteControllerGetNotesPath = '/notes/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotes$Response(params: GetNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Note>>> {
    return getNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotes(params: GetNotes$Params, context?: HttpContext): Observable<Array<Note>> {
    return this.getNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Note>>): Array<Note> => r.body)
    );
  }

  /** Path part for operation `noteControllerUpdateNote()` */
  static readonly NoteControllerUpdateNotePath = '/notes/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNote$Response(params: UpdateNote$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateNote(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNote(params: UpdateNote$Params, context?: HttpContext): Observable<void> {
    return this.updateNote$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `noteControllerCreateNote()` */
  static readonly NoteControllerCreateNotePath = '/notes/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNote$Response(params: CreateNote$Params, context?: HttpContext): Observable<StrictHttpResponse<Note>> {
    return createNote(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNote(params: CreateNote$Params, context?: HttpContext): Observable<Note> {
    return this.createNote$Response(params, context).pipe(map((r: StrictHttpResponse<Note>): Note => r.body));
  }

  /** Path part for operation `noteControllerGetNote()` */
  static readonly NoteControllerGetNotePath = '/notes/{entityClass}/{entityId}/{noteId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNote$Response(params: GetNote$Params, context?: HttpContext): Observable<StrictHttpResponse<Note>> {
    return getNote(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNote(params: GetNote$Params, context?: HttpContext): Observable<Note> {
    return this.getNote$Response(params, context).pipe(map((r: StrictHttpResponse<Note>): Note => r.body));
  }

  /** Path part for operation `noteControllerDeleteNote()` */
  static readonly NoteControllerDeleteNotePath = '/notes/{entityClass}/{entityId}/{noteId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNote()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNote$Response(params: DeleteNote$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteNote(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNote(params: DeleteNote$Params, context?: HttpContext): Observable<void> {
    return this.deleteNote$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
